export const AppDefaultSetting = {
  currentAppId: 'ff161805-fb73-4387-b697-2cd8702e3f49',
  showAsideMenu: false,
  defaultLanguageOfPanel: 'en',
  defaultLanguage: {
    isO2: 'en',
  },
  currentAppUpgradedToAppSumo: false,
};
